import { render, staticRenderFns } from "./leaveList.vue?vue&type=template&id=30d167fc&scoped=true&"
import script from "./leaveList.vue?vue&type=script&lang=js&"
export * from "./leaveList.vue?vue&type=script&lang=js&"
import style0 from "./leaveList.vue?vue&type=style&index=0&id=30d167fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d167fc",
  null
  
)

export default component.exports